import { createAction } from '@reduxjs/toolkit';

export const widgetDataCleanUp = createAction('widgetDataCleanUp');

export const widgetDataUpdate = createAction('widgetDataUpdate');
